import { useNavigate } from "react-router-dom";

export const RoleManagementRoutesComponent = () => {
	const navigate = useNavigate();
	const ArrayData = [
		{
			label: "Menu Heads",
			command: () => {
				navigate("/role-management/menu-heads");
			},
		},
		{
			label: "Screen Setup",
			command: () => {
				navigate("/role-management/screen");
			},
		},
		{
			label: "Screen Permissions",
			command: () => {
				navigate("/role-management/screen-permissions");
			},
		},
		{
			label: "Users",
			command: () => {
				navigate("/role-management/users");
			},
		},
		{
			label: "Roles",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/role-management/role");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/role-management/role/setup");
					},
				}
			]
		},
		{
			label: "Role Assignment",
			items: [
				{
					label: "List ",
					command: () => {
						navigate("/role-management/role-assignment");
					},
				},
				{
					label: "Setup ",
					command: () => {
						navigate("/role-management/role-assignment/setup");
					},
				}
			]
		},
	];

	return {
		RoleManagementRoutes: ArrayData,
	};
};
